<template>
  <div id="dl-menu" class="dl-menuwrapper mobile-only">
    <button class="dl-trigger">Open Menu</button>
    <ul class="dl-menu">
      <li>
        <a class="first-item" href="#">COOLOC</a>
        <ul class="dl-submenu">
          <li>
            <router-link
              :to="{name: 'Conduct'}"
              target="_blank"
              title="Voir note charte de bonne conduite">
              Charte de bonne conduite
            </router-link>
          </li>
          <li><a href="https://cooloc.com/blog/" target="_blank" title="Découvrir nos conseils utiles">Conseils utiles</a></li>
        </ul>
      </li>
      <li>
        <a class="first-item" href="#">À propos</a>
        <ul class="dl-submenu">
          <li>
            <router-link
              :to="{name: 'About'}"
              target="_blank"
              title="Découvrir qui nous sommes">
              Qui sommes-nous ?
            </router-link>
          </li>
          <li>
            <router-link
              :to="{name: 'CGU'}"
              target="_blank"
              title="Voir nos conditions générales d\'utilisation">
              CGU
            </router-link>
          </li>
          <li>
            <router-link
              :to="{name: 'Mentions'}"
              target="_blank"
              title="Voir nos informations légales">
              Mentions légales
            </router-link>
          </li>
        </ul>
      </li>
      <li>
        <a class="first-item" href="#">Outils</a>
        <ul class="dl-submenu">
          <li>
            <router-link
              :to="{name: 'Contact'}"
              target="_blank"
              title="Pour nous contacter">
              Contactez-nous
            </router-link>
          </li>
          <!--li><a href="#" title="Voir le plan du site">Plan du site</a></li-->
          <li>
            <router-link
              :to="{name: 'FAQ'}"
              target="_blank"
              title="Voir notre foire aux questions">
              FAQ
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div><!-- /dl-menuwrapper -->
</template>

<script>
export default {
  name: 'menu-burger-mobile',
  mounted: function () {
    jQuery(function ($) {
      $('#dl-menu').dlmenu({
        animationClasses: { classin: 'dl-animate-in-2', classout: 'dl-animate-out-2' },
      })
    })
  },
}
</script>
